import React from 'react';
import { ExternalLinkIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-clinical-blue pt-12 pb-8 sm:pt-20 sm:pb-10 text-white" data-id="element-99">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-100">
        <div className="grid lg:grid-cols-4 gap-10 sm:gap-12 mb-12 sm:mb-20" data-id="element-101">
          <div className="lg:col-span-1" data-id="element-102">
            <span className="text-xl sm:text-2xl font-black tracking-tight text-white uppercase block mb-4 sm:mb-6" data-id="element-103">
              Daily Care Pharmacy
            </span>
            <p className="text-blue-100 text-sm leading-relaxed max-w-xs" data-id="element-104">
              Your trusted local digital pharmacy, providing professional care
              and wellness essentials to our communities.
            </p>
          </div>

          <div data-id="element-105">
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-blue-300 mb-8" data-id="element-106">
              Annapolis Store
            </h4>
            <div className="space-y-6" data-id="element-107">
              <p className="text-white text-base font-medium" data-id="element-108">
                2002 Jennifer Rd
                <br data-id="element-109" />
                Annapolis, MD 21401
              </p>
              <div className="text-sm text-blue-100 space-y-1" data-id="element-110">
                <p data-id="element-111">Mon - Fri: 9:00 AM - 7:00 PM</p>
                <p data-id="element-112">Sat: 10:00 AM - 4:00 PM</p>
                <p data-id="element-113">Sun: Closed</p>
              </div>
              <a href="#" className="text-white font-bold text-xs uppercase tracking-widest hover:underline flex items-center gap-2" data-id="element-114">
                Google Business Profile <ExternalLinkIcon className="w-4 h-4" data-id="element-115" />
              </a>
            </div>
          </div>

          <div data-id="element-116">
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-blue-300 mb-8" data-id="element-117">
              Washington D.C. Store
            </h4>
            <div className="space-y-6" data-id="element-118">
              <p className="text-white text-base font-medium" data-id="element-119">
                1234 Pennsylvania Ave NW
                <br data-id="element-120" />
                Washington, D.C. 20004
              </p>
              <div className="text-sm text-blue-100 space-y-1" data-id="element-121">
                <p data-id="element-122">Mon - Fri: 8:30 AM - 6:30 PM</p>
                <p data-id="element-123">Sat: 10:00 AM - 2:00 PM</p>
                <p data-id="element-124">Sun: Closed</p>
              </div>
              <a href="#" className="text-white font-bold text-xs uppercase tracking-widest hover:underline flex items-center gap-2" data-id="element-125">
                Google Business Profile <ExternalLinkIcon className="w-4 h-4" data-id="element-126" />
              </a>
            </div>
          </div>

          <div data-id="element-127">
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-blue-300 mb-8" data-id="element-128">
              Quick Links
            </h4>
            <ul className="space-y-4" data-id="element-129">
              <li data-id="element-130">
                <a href="#" className="text-white text-sm font-bold uppercase tracking-widest hover:text-blue-200" data-id="element-131">
                  Prescriptions
                </a>
              </li>
              <li data-id="element-132">
                <a href="#" className="text-white text-sm font-bold uppercase tracking-widest hover:text-blue-200" data-id="element-133">
                  OTC Products
                </a>
              </li>
              <li data-id="element-134">
                <a href="#" className="text-white text-sm font-bold uppercase tracking-widest hover:text-blue-200" data-id="element-135">
                  Vaccines
                </a>
              </li>
              <li data-id="element-136">
                <a href="#" className="text-blue-200 text-sm font-bold uppercase tracking-widest hover:underline" data-id="element-137">
                  The VIEW (DC Admin)
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-10 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-138">
          <p className="text-blue-200 text-xs font-bold uppercase tracking-widest" data-id="element-139">
            © 2026 DAILY CARE PHARMACY.
          </p>
          <div className="flex gap-8" data-id="element-140">
            <Link to="/privacy" className="text-blue-200 hover:text-white text-xs font-bold uppercase tracking-widest transition-colors" data-id="element-141">
              Privacy
            </Link>
            <Link to="/terms" className="text-blue-200 hover:text-white text-xs font-bold uppercase tracking-widest transition-colors" data-id="element-142">
              Terms
            </Link>
            <Link to="/hipaa" className="text-blue-200 hover:text-white text-xs font-bold uppercase tracking-widest transition-colors" data-id="element-143">
              HIPAA
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}